import {
  GridColDef,
  GridCsvExportOptions,
  GridCsvGetRowsToExportParams,
  GridPrintExportOptions,
  gridFilteredSortedRowIdsSelector,
  gridSortedRowIdsSelector,
  gridVisibleColumnFieldsSelector,
  useGridApiContext,
} from "@mui/x-data-grid";
import React, { useState } from "react";
import { useDispatch } from "../../store";
import { Button, ButtonProps } from "@mui/material";
import { Email, GetApp } from "@mui/icons-material";
import { GridApiCommunity } from "@mui/x-data-grid/internals";

interface Props {
  totalRows: number;
  handlePreExport: () => Promise<void>;
  columns: GridColDef[];
}

const TableToolbar: React.FC<Props> = (props) => {
  const { totalRows, handlePreExport, columns } = props;
  const apiRef = useGridApiContext();
  const dispatch = useDispatch();
  const [emailModal, setEmailModal] = useState<{
    visible: boolean;
    type?: "pdf" | "excel";
  }>({ visible: false });

  const getAllRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridSortedRowIdsSelector(apiRef);

  const getExcelData = (apiRef: React.MutableRefObject<GridApiCommunity>) => {
    const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
    const visibleColumnFields = gridVisibleColumnFieldsSelector(apiRef);
    const columns = visibleColumnFields.filter((c) => c !== "actions");

    const data = filteredSortedRowIds.map((id) => {
      let row: any = {};
      columns.forEach((field) => {
        row[field] = apiRef.current.getCellParams(id, field).value;
      });
      return row;
    });
    return data;
  };

  const handleExportAllExcel = (options: GridCsvExportOptions) => {
    handlePreExport?.().then(() => {
      apiRef.current.setPageSize(totalRows!);

      // apiRef.current.exportDataAsCsv({
      //   ...options,
      //   fileName: `Report-export${moment(new Date()).format("MM/DD/YY")}`,
      // });

      // const data = getExcelData(apiRef);

      // const worksheet = XLSX.utils.json_to_sheet(data);
      // XLSX.utils.sheet_add_aoa(
      //   worksheet,
      //   [
      //     [
      //       ...columns
      //         .filter((c) => c.headerName !== "Actions")
      //         .map((c) => {
      //           return c.headerName;
      //         }),
      //     ],
      //   ],
      //   { origin: "A1" }
      // );

      // const workbook = XLSX.utils.book_new();
      // XLSX.utils.book_append_sheet(workbook, worksheet, "Hours Report");

      // XLSX.writeFile(
      //   workbook,
      //   `Report-export${moment(new Date()).format("MM/DD/YY")}.xlsx`,
      //   { compression: true }
      // );
    });
  };

  const handleExportAllPrint = (options: GridPrintExportOptions) => {
    handlePreExport?.().then(() => {
      apiRef.current.setPageSize(totalRows!);
      apiRef.current.exportDataAsPrint({
        ...options,
        pageStyle: "landscape",
      });
    });
  };

  const handleEmailPdf = (emails: string[]) => {
    //   handlePreExport?.().then(async () => {
    //     apiRef.current.setPageSize(totalRows!);
    //     const blob = await pdf(
    //       <ReportPdfView text={apiRef.current.getDataAsCsv({})} />
    //     ).toBlob();
    //     dispatch(emailJobTimeReport({ blob: blob, type: "pdf", email: emails }));
    //   });
  };

  const handleEmailExcel = (emails: string[]) => {
    //   handlePreExport?.().then(async () => {
    //     apiRef.current.setPageSize(totalRows!);
    //     const data = getExcelData(apiRef);
    //     const worksheet = XLSX.utils.json_to_sheet(data);
    //     XLSX.utils.sheet_add_aoa(
    //       worksheet,
    //       [
    //         [
    //           ...columns
    //             .filter((c) => c.headerName !== "Actions")
    //             .map((c) => {
    //               return c.headerName;
    //             }),
    //         ],
    //       ],
    //       { origin: "A1" }
    //     );
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Hours Report");
    //     const file = await XLSX.write(workbook, {
    //       type: "array",
    //     });
    //     const blob = await new Blob([file], {
    //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
    //     });
    //     dispatch(
    //       emailJobTimeReport({ blob: blob, type: "excel", email: emails })
    //     );
    //   });
  };

  const exportButtonBaseProps: ButtonProps = {
    color: "primary",
    size: "small",
    startIcon: <GetApp />,
  };

  const emailButtonBaseProps: ButtonProps = {
    ...exportButtonBaseProps,
    startIcon: <Email />,
  };

  return (
    <>
      <Button
        {...exportButtonBaseProps}
        onClick={() => {
          handleExportAllExcel({ getRowsToExport: getAllRows });
        }}
      >
        Export All as Excel
      </Button>
      {/* <Button
        {...emailButtonBaseProps}
        onClick={() => {
          setEmailModal({ visible: true, type: "excel" });
        }}
      >
        Email All as Excel
      </Button> */}
      {/* <Button
        {...exportButtonBaseProps}
        onClick={() => {
          handleExportAllPrint({ getRowsToExport: getAllRows });
        }}
      >
        Print All
      </Button> */}
      <Button
        {...exportButtonBaseProps}
        onClick={() => {
          // setEmailModal({ visible: true, type: "pdf" });
        }}
      >
        Export All as PDF
      </Button>
    </>
  );
};

export default TableToolbar;
